import type { RaceSummary } from "@/api";
import { trackTitle } from "@/features/racing/venue";

import { localTime } from "./scheduleState";

export function ScheduleRaceRail({
  races,
  now,
  selected,
  detailsId,
  onSelect,
}: {
  races: RaceSummary[];
  now: number;
  selected: string | null;
  detailsId: string;
  onSelect: (race: RaceSummary) => void;
}) {
  // This intentionally short rail supplements the complete calendar, never replaces it.
  const next = races
    .filter(
      (race) =>
        Date.parse(race.scheduledAt) >= now &&
        !["official", "abandoned", "voided", "cancelled"].includes(race.status),
    )
    .slice(0, 4);
  if (!next.length) return null;
  return (
    <section className="schedule-next" aria-label="Next up in displayed window">
      <h2>
        Next up <span>In this window</span>
      </h2>
      <div className="schedule-next__rail">
        {next.map((race) => (
          <button
            type="button"
            key={race.raceId}
            className="schedule-next__card"
            aria-label={`Next up: ${trackTitle(race)} · ${race.distanceM}m · ${localTime(race.scheduledAt)}`}
            aria-pressed={selected === race.raceId}
            aria-expanded={selected === race.raceId}
            aria-controls={detailsId}
            onClick={() => onSelect(race)}
          >
            <time dateTime={race.scheduledAt}>
              {localTime(race.scheduledAt)}
            </time>
            <strong>{trackTitle(race)}</strong>
            <span>
              {race.raceNumber ? `${race.raceNumber} · ` : ""}
              {race.distanceM}m · {race.fieldSize} runners
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
